import React, { Component } from "react";
import PropTypes from "prop-types";

import OtsView from "react/views/ots/OtsView";
import { getAvailability } from "data/OtsRequests";
import { getAvailabilityForId } from "data/OtsSelector";
import { getTitleUi } from "data/TitleInfoSelector";
import { getJsonData } from "data/DataStore";

class OtsContainer extends Component {
	constructor() {
		super();

		this.state = {
			error: false,
			loading: true,
			render: true
		};

		this.setAvailability = this.setAvailability.bind(this);
		this.otsRequestError = this.otsRequestError.bind(this);
		this.verifyAvailability = this.verifyAvailability.bind(this);
	}

	otsRequestError() {
		this.setState({ error: true, loading: false });
	}
	componentWillReceiveProps(nextProps){
		if(this.props.item.uniqueId !== nextProps.item.uniqueId){
			this.updateAvailability(nextProps.item.uniqueId);
		}
	}
	componentDidMount() {
		this.updateAvailability(this.props.item.uniqueId);
	}
	updateAvailability(uniqueId){
		// By calling Promise.resolve with the returned value
		// we guarantee that it is a promise whether it originally was or not
		Promise.resolve(getAvailability(uniqueId))
			.then((value) => this.verifyAvailability(value, uniqueId))
			.catch((err) => {
				this.otsRequestError();
				console.error(err); // eslint-disable-line no-console
			});
	}

	verifyAvailability(availability, uniqueId) {
		if(availability !== undefined) {
			let availabilityForId = getAvailabilityForId(availability, uniqueId);
			if (availabilityForId) {
				this.setAvailability(availabilityForId);
			} else {
				this.otsRequestError();
			}
		} else {
			//The api has not returned an OTS Relative Url, so don't display this component
			this.setState({ render: false });
		}
	}

	setAvailability(availability) {
		this.setState({
			availability: availability.items,
			loading: false
		});
	}

	render() {
		const { loading, availability, error, render } = this.state;
		const { otsEnabled, item, otsFindItEvent, loggingDestId, otsClickEvent } = this.props;

		let otsClickLogging = {
			srcId: getTitleUi(getJsonData()),
			destId: loggingDestId,
			featureType: otsClickEvent
		}

		if(!otsEnabled || !render) {
			return null;
		}

		return <OtsView 
			data={availability} 
			loading={loading} 
			error={error} 
			uniqueId={item.uniqueId} 
			catalogLink={item.catalogLink}
			otsFindItEvent = {otsFindItEvent}
			otsClickLogging = {otsClickLogging}
			/>;
	}
}

OtsContainer.propTypes = {
	item: PropTypes.shape({
		uniqueId: PropTypes.string,
		catalogLink: PropTypes.object
	}).isRequired
};

export default OtsContainer;



// WEBPACK FOOTER //
// ./src/react/containers/OtsContainer.jsx